<template>
  <div>
    <!-- 新建/编辑题库（抽屉） -->
    <yxt-form ref="form"
              :model="libForm"
              label-position="top"
              size="small"
              :rules="rules"
              label-width="76px">
      <!-- 题库分类 -->
      <yxt-form-item :label="$t('pc_biz_ote_lbl_queslibcatalog')" prop="catalogId" :error="validCatalogMsg">
        <catalogDropdown :data="datas" :catalogId.sync="libForm.catalogId" :catalogName.sync="libForm.catalogName" @change="catalogChange"></catalogDropdown>
      </yxt-form-item>
      <!-- 题库名称 -->
      <!-- 共享中心tag标识 题库名称不可编辑 this.libForm.libId 新建or 编辑-->
      <yxt-form-item :label="$t('pc_biz_ote_lbl_quesbankname')" prop="name" :error="validNameMsg">
        <!-- 请输入题库名称 -->
        <yxt-input v-model="libForm.name"
                   :disabled="shareSourceType ===1"
                   :placeholder="$t('pc_ote_msg_inputqueslibname')"
                   maxlength="200"
                   show-word-limit></yxt-input>
      </yxt-form-item>
      <!-- 题库保密 -->
      <!-- 共享中心tag标识 题库保密不可编辑 this.libForm.libId  新建or 编辑-->
      <yxt-form-item :label="$t('pc_ote_lbl_queslibsecrecy')">
        <yxt-radio-group v-model="libForm.secrecy" :disabled="shareSourceType === 1">
          <!-- 公开题库-tooltip提示 -->
          <yxt-radio v-if="checkActionAdminPermission('questionBank_add_oepn_operate')" :label="0" :disabled="false">{{ $t('pc_ote_lbl_public') }}</yxt-radio>
          <yxt-tooltip v-else :content="$t('pc_ote_no_open_queslib_create_per' /* 无公开题库创建权限，如有疑问请联系管理员 */)" placement="top">
            <yxt-radio :label="0" disabled="lock">{{ $t('pc_ote_lbl_public') }}</yxt-radio>
          </yxt-tooltip>
          <!-- 保密题库-tooltip提示 -->
          <yxt-radio v-if="checkActionAdminPermission('questionBank_add_private_operate')" :label="1" :disabled="false">{{ $t('pc_ote_tip_secrecy') }}</yxt-radio>
          <yxt-tooltip v-else :content="$t('pc_ote_no_secret_queslib_create_per' /* 无保密题库创建权限，如有疑问请联系管理员 */)" placement="top">
            <yxt-radio :label="1" disabled="lock">{{ $t('pc_ote_tip_secrecy') }}</yxt-radio>
          </yxt-tooltip>
        </yxt-radio-group>
        <!-- 仅支持创建者及超级管理员编辑及使用 -->
        <span class="color-gray-7 v-mid d-in-block mt2">（{{ $t('pc_ote_tip_questionbanksecrecyeditable') }}）</span>
      </yxt-form-item>
    </yxt-form>
  </div>
</template>

<script>
import { getCatalogList, createQuesLib, updateQuesLib, getQuesLibDetail } from '../service';
import CatalogDropdown from 'packages/question-selector/src/selector/catalogDropdown.vue';
import rootCatalog from 'packages/question-selector/src/selector/rootCatalog.js';
import utils from '../utils';

export default {
  name: 'quesLibDetail',
  components: {
    CatalogDropdown
  },
  mixins: [rootCatalog],
  props: ['libId', 'catalogId', 'catalogName', 'createType'],
  data() {
    const validateName = (rule, value, callback) => {
      if (value === '') {
        // 请输入题库名称
        callback(new Error(this.$t('pc_ote_msg_inputqueslibname')));
      }
    };
    const validateCatalog = (rule, value, callback) => {
      if (value === '') {
        // 请选择题库分类
        callback(new Error(this.$t('pc_ote_msg_selectqueslibcatalog')));
      }
    };
    return {
      shareSourceType: '',
      loaded: false,
      datas: this.wrapRootCatalog(),
      // 抽屉的题库实体
      libForm: {
        catalogId: '', // 试题库分类ID
        catalogName: '', // 试题库分类名称
        name: '', // 试题库名称
        secrecy: 0, // 是否保密 0-否 1-是
        libId: this.libId // 试题库ID（编辑时有值）
      },
      validCatalogMsg: '',
      validNameMsg: '',
      rules: {
        // 中文校验
        catalogId: [
          { required: true, validator: validateCatalog, trigger: 'change' }
        ],
        name: [
          { required: true, validator: validateName, trigger: 'blur' }
        ]
      },
      changeCatalogInfo: {}, // 筛选的分类
      copyLibForm: '' // 复制出来的值用于后续比对
    };
  },

  computed: {
    isChange() {
      return this.copyLibForm !== JSON.stringify(this.libForm);
    }
  },

  created() {
    this.setCatalogType(0);
    if (this.catalogId && this.catalogName) {
      this.libForm.catalogId = this.catalogId;
      this.libForm.catalogName = this.catalogName;
    }
    this.getLibCatalog();
    this.getLibDetail();

    this.copyLibForm = JSON.stringify(this.libForm);
  },
  methods: {
    // 默认题库走题库导航的权限
    checkActionAdminPermission(fc, ac) {
      if (!ac) {
        ac = fc;
        fc = 'ote_ques_lib_mgmt';
      }
      return utils.checkActionAdminPermission(fc, ac, this);
    },
    // 试题库分类树
    getLibCatalog() {
      getCatalogList().then(catalogs => {
        this.datas = this.initCatalogList(catalogs);
      });
    },
    // 获取试题库详情
    getLibDetail() {
      if (this.libId) {
        getQuesLibDetail(this.libId).then(res => {
          if (res.catalogId) {
            this.libForm.catalogId = res.catalogId;
            this.libForm.catalogName = res.catalogName;
          } else {
            // 如果后端返回的是空串，则表示根分类
            this.libForm.catalogId = this.ROOT_CATALOG_ID;
            this.libForm.catalogName = this.ROOT_CATALOG_NAME;
          }
          this.shareSourceType = res.shareSourceType;
          this.libForm.name = res.name;
          this.libForm.secrecy = res.secrecy;
          this.libForm.libId = res.id;
          this.$nextTick(() => {
            this.loaded = true;
          });
        });
      } else {
        // 无创建公开题库权限，默认选择保密题库
        if (!this.checkActionAdminPermission('questionBank_add_oepn_operate') && this.checkActionAdminPermission('questionBank_add_private_operate')) {
          this.libForm.secrecy = 1;
        }
        this.$nextTick(() => {
          this.loaded = true;
        });
      }
    },
    // 新建/编辑试题库
    save() {
      if (!this.libForm.catalogId) {
        this.validCatalogMsg = this.$t('pc_ote_msg_selectqueslibcatalog'); // 请选择题库分类
        this.$emit('saveBtnStatus');
        return false;
      }
      if (!this.libForm.name.trim()) {
        this.validNameMsg = this.$t('pc_ote_msg_inputqueslibname'); // 请输入题库名称
        this.$emit('saveBtnStatus');
        return false;
      }
      if (this.libForm.libId) {
        // 编辑
        updateQuesLib(this.libForm.libId, this.libForm).then(res => {
          this.$message({
            type: 'success',
            message: this.$t('pc_ote_msg_editsuccess') // 编辑成功！
          });
          this.closeLibDrawer(1);
        }).catch((err) => {
          this.$emit('saveBtnStatus');
          this.handleError(err);
        });
      } else {
        this.libForm.createType = this.createType;
        // 新建
        createQuesLib(this.libForm).then(res => {
          // 题库是否禁用
          if (res.catDisabled) {
            this.$message.warning(this.$t('pc_biz_ote_msg_create_success_disabled' /* 新建成功，但此题库对应分类已被禁用！ */));
          } else {
            this.$message.success(this.$t('pc_ote_msg_createsuccess' /* 新建成功！ */));
          }

          this.closeLibDrawer(1, res);
        }).catch((err) => {
          this.$emit('saveBtnStatus');
          this.handleError(err);
        });
      }
    },
    // 关闭抽屉
    closeLibDrawer(type, catalogInfo) {
      this.$emit('closeLibDrawer');
      if (type && type === 1) {
        this.$emit('search', { ...catalogInfo, changeCatalogInfo: this.changeCatalogInfo });
      }
    },

    catalogChange(data) {
      this.changeCatalogInfo = data;
    }
  }
};
</script>
